

/*
   @payment
   @input 
   @result
*/
const Online = ()=>{
  
    return (
        <>
           
            <p>online page</p>
            
        </>
    );

};

export default Online;
